'use client'

import { useEffect } from 'react'

import { PrimaryButton } from '@/components/Buttons'
import { toast } from '@/components/ui/use-toast'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset?: () => void }) {
  useEffect(() => {
    // Log the error to an error reporting service
    toast({
      title: 'An error occurred',
      description: error.message,
      variant: 'error',
    })
  }, [error])

  return (
    <div className='flex h-full w-full items-center justify-center'>
      <div className='flex max-w-2xl flex-col items-center justify-center gap-2'>
        <h2>Something went wrong!: {error?.message}</h2>
        <PrimaryButton
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset?.()
          }
        >
          Try again
        </PrimaryButton>
      </div>
    </div>
  )
}
